import { render, staticRenderFns } from "./BlocklyEditor.vue?vue&type=template&id=282110cc&"
import script from "./BlocklyEditor.vue?vue&type=script&lang=js&"
export * from "./BlocklyEditor.vue?vue&type=script&lang=js&"
import style0 from "./BlocklyEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports